export default {
  27: 'Pago externo',
  28: 'Acoge beneficio',
}
